module.exports = __webpack_public_path__ + "static/rick-008-9e269b7981a4511b9495f80b328e9880.jpg";